export class ChiMessagePayload {
  type: string
  payload: any

  constructor(params: ChiMessagePayloadParameters) {
    this.type = params.type
    this.payload = params.payload
  }
}

export interface ChiMessagePayloadParameters {
  type: string
  payload?: any
}
